

























import Vue from 'vue';
import Upload from '@/components/common/Upload.vue';
import BackgroundClipping from '../BackgroundClipping.vue';

export default Vue.extend({
  name: 'card-form',
  components: { Upload, BackgroundClipping },
  props: {
    src: String,
    alt: String,
    title: String,
    hideImage: Boolean,
  },
  methods: {
    copy(e: Event) {
      this.$emit('copy', e);
    },
    remove(e: Event) {
      this.$emit('delete', e);
    },
    improveImage(url: string) {
      this.$emit('improve', url);
    },
    openClippingModal() {
      (this.$refs.clippingModal as BackgroundClipping).openWithUrl(this.src);
    },
    onFiles(files: File[]) {
      if (files[0]) {
        this.$emit('file', files[0]);
      }
    },
  },
});
